import {Pipe, PipeTransform} from '@angular/core';
import {TitleCasePipe} from '@angular/common';

@Pipe({
  standalone: false,name: 'camelToTitleCase'})
export class CamelToTitleCasePipe extends TitleCasePipe implements PipeTransform{

  // @ts-ignore
  transform(value: string): string {
    if (value != null) {
     const newValue = value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
     return super.transform(newValue);
    }
    return value;
  }
}
